import React from "react";

const SvgComponent = props => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <g data-name="路径 150" fill="none">
      <path d="M13.91 18v-1.637H4.092V18H.004v-4.091h1.637V4.09H.004V0h4.092v1.635h9.818V0h4.09v4.089h-1.635v9.819h1.635V18z" />
      <path
        d="M17 16.999v-2.09h-1.635V3.088H17V1h-2.09v1.635H3.092V1H1v2.089h1.637v11.82H1v2.09h2.092v-1.637H14.91V17H17m1 1h-4.09v-1.637H4.092V18H0v-4.09h1.637v-9.82H0V0h4.092v1.635h9.818V0H18v4.089h-1.635v9.82H18v4.09z"
        fill="#464646"
      />
    </g>
    <g data-name="路径 152" fill="none">
      <path d="M.002 0h4.1v4.1h-4.1z" />
      <path
        d="M1.002 1v2.099h2.099V1H1.002m-1-1h4.099v4.099H.002V0z"
        fill="#464646"
      />
    </g>
    <g data-name="路径 153" fill="none">
      <path d="M.002 13.899h4.1v4.1h-4.1z" />
      <path
        d="M1.002 14.899v2.099h2.099v-2.099H1.002m-1-1h4.099v4.099H.002v-4.099z"
        fill="#464646"
      />
    </g>
    <g data-name="路径 154" fill="none">
      <path d="M13.9 0H18v4.1h-4.1z" />
      <path
        d="M14.9 1v2.099h2.099V1H14.9m-1-1h4.099v4.099H13.9V0z"
        fill="#464646"
      />
    </g>
    <g data-name="路径 151" fill="none">
      <path d="M13.9 13.899H18v4.1h-4.1z" />
      <path
        d="M14.9 14.899v2.099h2.099v-2.099H14.9m-1-1h4.099v4.099H13.9v-4.099z"
        fill="#464646"
      />
    </g>
  </svg>
);

export default SvgComponent;
